import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';

function CircularProgressWithLabel({
  value,
  color = '#000',
  valueWidth = '55px',
  ...rest
}) {
  let val = Number.parseFloat(value);

  if (isNaN(val)) val = 0;
  if (val < 0) val = 0;

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
      <span
        style={{
          width: valueWidth,
          fontWeight: 500,
          height: '100%',
          alignItems: 'center',
        }}
      >{`${val}%`}</span>

      <CircularProgress
        aria-hidden='true'
        size={30}
        thickness={6}
        value={Math.min(val, 100)}
        variant='determinate'
        {...rest}
        sx={{
          color: color,
          boxShadow: 'inset 0 0 1px 3.5px rgb(229, 224, 224)',
          borderRadius: '50%',
          backgroundColor: 'transparent',
        }}
      />
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  color: PropTypes.string,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default CircularProgressWithLabel;
